import { TableCell, TableCellProps } from "@/components";

export type Props = TableCellProps;

export const TableCellHead: React.FC<Props> = (props) => {
  return <TableCell {...props} component="th" />;
};
